import { ModelBase } from 'store/model-base';
import { ReturnFeeCategory } from 'my-account/constants';

export class ReturnFee extends ModelBase {
    public static storeName: string = 'returnFee';

    public category: ReturnFeeCategory;
    public amount: number;

    public get isRestocking(): boolean {
        return this.category === ReturnFeeCategory.RESTOCKING;
    }

    public get isDamage(): boolean {
        return this.category === ReturnFeeCategory.DAMAGE;
    }
}
